'use strict';
import React from 'react';
import reactDom from 'react-dom';
import { Link } from 'react-router-dom';
import userAction from '../../actions/userAction';
import userStore from '../../stores/userStore';

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            warningMsg: userStore.getState().warningMsg,
            processing: userStore.getState().processing,
            isfgPwdSend: userStore.getState().isfgPwdSend,
            email: ""
        }
    }

    componentDidMount() {
        userStore.listen(this.onChange);
        userAction.warningMsg('');
    }
    componentDidUpdate(prevProps, prevState) {
        if (!prevState.isfgPwdSend && this.state.isfgPwdSend != prevState.isfgPwdSend) {
            
            window.setTimeout(() => {
                this.props.history.push('/');
            }, 3000);

        }
    }
    componentWillUnmount() {
        userStore.unlisten(this.onChange);
    }

    onChange(state) {
        this.setState({
            warningMsg: state.warningMsg,
            processing: state.processing,
            isfgPwdSend: state.isfgPwdSend,
        });
    }

    handleChange(e) {
        let value = e.target.value;
        this.setState({ email: value });

    }
    handleKeyPress(e){
        if(e.key == 'Enter'){
            e.preventDefault();
            this.handleSubmit();
        }
    }
    handleSubmit(e) {
        let email = reactDom.findDOMNode(this.refs.email);
        try{
            email.reportValidity();
        }catch(e){

        }
    
        if (!email.checkValidity()) return;

        if (this.state.processing) return;
        
        if (!this.validateEmail(this.state.email)) {
            userAction.warningMsg("Invalid Email");
        } else {
            userAction.processing(true);
            userAction.forgotPassword(this.state.email);
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    render() {
        return (

            <div className="ul-w">
                <h2> A4 International </h2>
                <div className="ul-tt">Forgot Password</div>
                <div className="ul-warning">{this.state.warningMsg}</div>
                <form>
                    <div className="form-group">
                        <div className="ul-in">
                            <input type="email" ref="email" className="form-control" placeholder="Your Email Address" 
                                onChange={this.handleChange} onKeyPress={this.handleKeyPress} required/>
                        </div>
                    </div>
                    <button type="button" className="btn btn-default" onClick={this.handleSubmit}>Send</button>
                </form>
            </div>
        );
    }
}
export default ForgotPassword;


// WEBPACK FOOTER //
// ./app/components/userComponents/forgotPassword.js